import { material } from "../../../Model/Product";

type GoldColorValue = "yellow" | "pink" | "white";

interface ColorSwatchesProps {
  material: material;
  selectedValue: string;
  onSelect: (value: string) => void;
}

const GOLD_SWATCHES: { value: GoldColorValue; label: string; hex: string }[] = [
  { value: "yellow", label: "Žuto zlato", hex: "#D9B44A" },
  { value: "pink", label: "Roze zlato", hex: "#D9A384" },
  { value: "white", label: "Belo zlato", hex: "#D8D5CC" },
];

export const ColorSwatches = ({
  material,
  selectedValue,
  onSelect,
}: ColorSwatchesProps) => {
  if (material !== "gold") {
    // silver (and any other/unset material) gets the fixed white swatch,
    // matching the original component's `data.material === "gold" ? ... : ...` branching.
    return (
      <div className="sp-swatch-row">
        <div className="sp-swatch sp-swatch--selected">
          <span
            className="sp-swatch-color"
            style={{ backgroundColor: "#E8E6E1" }}
          />
          <span className="sp-swatch-label">Bela</span>
        </div>
      </div>
    );
  }

  return (
    <div className="sp-swatch-row">
      {GOLD_SWATCHES.map(({ value, label, hex }) => {
        const isSelected = selectedValue === value;
        return (
          <button
            key={value}
            type="button"
            onClick={() => onSelect(value)}
            className={
              "sp-swatch" + (isSelected ? " sp-swatch--selected" : "")
            }
          >
            <span
              className="sp-swatch-color"
              style={{ backgroundColor: hex }}
            />
            <span className="sp-swatch-label">{label}</span>
          </button>
        );
      })}
    </div>
  );
};

export default ColorSwatches;

